import React, { Component } from 'react';
import { UserComponent } from '../../../../../UserComponent';
import { HealthComponent } from '../HealthComponent';


export default class RpgChatNotificationMessage extends Component {

	renderMessageText(messageText) {
		const { chatMessage } = this.props;

		const attack = chatMessage.rpg.attack;
		let strength = null;
		if(attack) {
			strength = attack.strength;
		}

		console.log('the messager', messageText, chatMessage);
		if(!strength) {
			strength = 1;
		}

		switch(messageText) {
			case '$attacker':
				return (
					<React.Fragment>
						<HealthComponent user={chatMessage.rpg.attacker} message={chatMessage} />
						<UserComponent user={chatMessage.rpg.attacker} />
					</React.Fragment>);
			case '$defender':
				return (
					<React.Fragment>
						<HealthComponent user={chatMessage.rpg.defender} message={chatMessage} />
						<UserComponent user={chatMessage.rpg.defender} />
					</React.Fragment>
				);
			case '$damage':
				return (
					<React.Fragment>
						<span className='number emphasized_bright'>{strength}</span>{' '}
						<span>damage</span>
					</React.Fragment>
				);
			default:
				if(isNumeric(messageText)) {
					return (<span className='number emphasized_bright'>{messageText}</span>);
				}
				else {
					return (<span>{messageText}</span>);
				}
		}
	}

	render() {
		const { chatMessage } = this.props;
		const message = Array.isArray(chatMessage.message) ? chatMessage.message : [chatMessage.message];

		return (
			<React.Fragment>
				{message.map((message, index) => {
					return (
						<React.Fragment key={index}>
							<span className='message'>
							{this.renderMessageText(message)}{' '}
							</span>
						</React.Fragment>
					);
				})}
			</React.Fragment>
		);

	}
}